import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import * as Icons from "lucide-react";

// dot = unseen activity inside this tile; critical = something in it needs action (number shown in red).
export function StatCard({ label, value, delta, deltaType = "up", icon = "Activity", accent = "indigo", testId, index = 0, onClick, dot = false, critical = false }) {
  const Icon = Icons[icon] || Icons.Activity;
  const accents = {
    indigo: "text-indigo-600 bg-indigo-50",
    emerald: "text-emerald-600 bg-emerald-50",
    amber: "text-amber-600 bg-amber-50",
    red: "text-red-600 bg-red-50",
    cyan: "text-cyan-600 bg-cyan-50",
    slate: "text-slate-600 bg-slate-100",
    primary: "text-primary bg-primary/10",
  };
  return (
    <Card
      data-testid={testId}
      onClick={onClick}
      className={cn(
        "relative p-5 transition-all duration-300 animate-fade-up",
        onClick ? "cursor-pointer hover:shadow-md hover:-translate-y-0.5 hover:border-primary/40" : "hover:shadow-md hover:-translate-y-0.5"
      )}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      {dot && <span className="cc-new-dot absolute top-3 right-3" title="New activity" data-testid={testId ? `${testId}-dot` : undefined} />}
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-mono uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className={cn("mt-2 font-heading text-2xl font-bold", critical ? "text-red-600" : "text-foreground")}>{value}</p>
        </div>
        <div className={cn(dot && "mr-3", "flex h-10 w-10 items-center justify-center rounded-lg", accents[accent] || accents.indigo)}>
          <Icon className="h-5 w-5" />
        </div>
      </div>
      {onClick && <p className="mt-3 text-[11px] font-medium text-primary flex items-center gap-1">View records <Icons.ArrowRight className="h-3 w-3" /></p>}
      {delta && !onClick && (
        <p className={cn("mt-3 text-xs font-medium", deltaType === "up" ? "text-emerald-600" : "text-red-600")}>
          {deltaType === "up" ? "▲" : "▼"} {delta}
        </p>
      )}
    </Card>
  );
}
